import React, { useContext, useState } from "react";
import './abmCategoriasRRHH.css';
import * as XLSX from 'xlsx';
import { createEstructuraABMCategoriaRRHH } from "../../utils/estructuras";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faBackspace} from "@fortawesome/free-solid-svg-icons";
import { useRef } from "react";
import productsContext from "../../context/productos/productsContext";
import Swal from 'sweetalert2';
import categoriasRRHHContext from "../../context/categoriasRRHHContext/categoriasRRHHContex";

const AbmCategoriasRRHH = ({setShowAbm = () => console.log('Cerrar'), categoriaToEdit = {}, setCategoriaToEdit = () => console.log('Set product to edit')}) => {
    const [categoriaEditing,setCategoriaEditing] = useState(categoriaToEdit);
    const [categoriasData,setCategoriasData] = useState([createEstructuraABMCategoriaRRHH()]);
    const fileInputRef = useRef(null);

    const cContext = useContext(categoriasRRHHContext);
    const {agregarCategoriasRRHH, modificarCategoriasRRHH, actualizarCategoriasRRHHList} = cContext;

    const handleChange = (e, i = -1) =>{
        const {name,value} = e.target;
        if(Object.keys(categoriaEditing).length > 0){
            setCategoriaEditing({...categoriaEditing, [name]: value});
        }else{
            setCategoriasData((prevData) => {
                let newCategorias = prevData.slice();
                if(value != ''){
                    if(newCategorias[i].codigo != '' && newCategorias[i].descrp != ''){
                        newCategorias[i][name] = value;
                    }else{
                        newCategorias[i][name] = value;
                        newCategorias.length == i+1 && newCategorias.push(createEstructuraABMCategoriaRRHH());
                    }
                }else{
                    newCategorias[i][name] = value;
                    if(newCategorias[i].codigo == '' && newCategorias[i].descrp == ''){
                        newCategorias.splice(i,1);
                    }
                }
                return newCategorias;
            })
        }

    }

    const handleFile = (file) => {
        if(file){
            const reader = new FileReader();
            reader.onload = (evt) => {
                const binaryString = evt.target.result;
                const wb = XLSX.read(binaryString, {type: 'binary'});
                const sheet = wb.Sheets[wb.SheetNames[0]];
                const jsonData = XLSX.utils.sheet_to_json(sheet,{header:1});
                let dataModelated = jsonData.filter((c,i) => i > 0 && c.length > 0).map((c) => {
                    let objectModelated;
                    c.forEach((value,index) => {
                        switch(index){
                            case 0: 
                                objectModelated = {codigo: value};
                                break;
                            case 1:
                                objectModelated = {...objectModelated, descrp: value};
                                break;
                            case 2:
                                objectModelated = {...objectModelated, basico: value};
                                break;
                            case 3:
                                objectModelated = {...objectModelated, basicoHora: value};
                                break;
                            case 4: 
                                objectModelated = {...objectModelated, adicional: value};
                                break;
                        }
                        objectModelated = {...objectModelated, origen:'M'};
                    })
                    return objectModelated
                });
                if(categoriasData.length > 0){
                    setCategoriasData([...dataModelated, ...categoriasData]);
                    setCategoriasData((prevCats) => {
                        let newCats = [...dataModelated];
                        newCats = [...newCats, ...prevCats.filter((c,i) => !dataModelated.some((cXlx) => c.codigo == cXlx.codigo || c.descrp == cXlx.descrp))];
                        return newCats;
                    });
                }else{
                    setCategoriasData([...dataModelated]);
                }
            }
            reader.readAsBinaryString(file);
        }
    }

    const handleChangeFile = (e) => {
        const file = e.target.files[0];
        handleFile(file);
    }

    const handleDelete = (categoria,i) => {
        if(categoria.codigo != ''){
            setCategoriasData((prevData) => {
                let newData = prevData.filter((p,index) => index != i);
                return newData;
            })
        }
    }

    const handleSave = async() => {
        if(Object.keys(categoriaEditing).length > 0){
            console.log("Here modificando categoria");
            let res = await modificarCategoriasRRHH(categoriaEditing);
            if(res.codigo){
                Swal.fire({
                    title:'Éxito!',
                    text:'Categoria actualizada correctamente',
                    icon:'success'
                })
            }
        }else{
            if(categoriasData.some((c,i) => i < categoriasData.length - 1 && (c.codigo == '' || c.descrp == '' || c.basico == 0 || c.basicoHora == 0))){
                let result = await Swal.fire({
                    title: `Ops!`,
                    icon: 'warning',
                    text: 'Ciertas categorias estan sin completar, desea omitirlas y guardar igual?',
                    showConfirmButton: true,
                    showCancelButton: true, // Habilita el botón de cancelar
                    confirmButtonColor: '#ff0000',
                    denyButtonColor: '#3d4d87',
                    confirmButtonText: 'Sí, estoy seguro',
                    cancelButtonText:'No',
                    allowEnterKey: true
                })
                if (result.isConfirmed ) {
                }else{
                    return false;
                }
            }
            let categoriasCompleted = categoriasData.filter((c) => c.codigo != '' && c.descrp != '');
            let counterSaved = 0;
            let counterFail = 0;
            for(const p of categoriasCompleted){
                try {
                    let res = await agregarCategoriasRRHH(p);
                    if(res == null) throw new Error("Clave Duplicada para Categoria " + p.codigo);
                    else counterSaved++;
                } catch (error) {
                    console.log("error intentando guardar la nueva categoria " + p.descrp);
                    console.log(error);
                    counterFail++;
                }
            }
            actualizarCategoriasRRHHList();
            Swal.fire({
                title:'Contador',
                icon: counterFail == 0 && counterSaved > 0 ? 'success' : counterFail > 0 && counterSaved == 0 ? 'error' : 'warning',
                html: `Categorias guardadas con Éxito: ${counterSaved}. <br>
                Categorias imposibles de guardarlas: ${counterFail}`,
            })
        }
        handleClose();
    }

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFile = e.dataTransfer.files[0];
        handleFile(droppedFile);
    }

    const handleClose = () => {
        if(Object.keys(categoriaToEdit).length > 0){
            setCategoriaEditing({});
            setCategoriaToEdit({});
        }
        setShowAbm(false)
    }

    return <div className="abmCategoriasRRHHModal">
        <div className="abmCategoriasRRHHDiv">
            <button className="minimizarBtn" onClick={handleClose}>X</button>
            <h2>{Object.keys(categoriaEditing).length == 0 ? 'Alta de Categoria RRHH' : 'Edición de Categoria RRHH'}</h2>

            <div className="productosLeidosSubtabla">
                <div className={`${Object.keys(categoriaEditing).length == 0 ? '' : 'fiveColumns'} labelsSubtablas`}>
                    {Object.keys(categoriaEditing).length == 0 && <label></label>}
                    <label>Codigo</label>
                    <label>Descripcion</label>
                    <label>Basico</label>
                    <label>Basico por Hora</label>
                    <label>Adicional</label>
                </div>
                {Object.keys(categoriaEditing).length > 0 
                ? 
                <div className={`${Object.keys(categoriaEditing).length == 0 ? '' : 'fiveColumns'} categoriaLoaded`}>
                    <input name="codigo" onChange={(e)=>handleChange(e)} value={categoriaEditing.codigo}/>
                    <input name="descrp" onChange={(e)=>handleChange(e)} value={categoriaEditing.descrp}/>
                    <input name="basico" type="number" onChange={(e)=>handleChange(e)} value={categoriaEditing.basico}/>
                    <input name="basicoHora" type="number" onChange={(e)=>handleChange(e)} value={categoriaEditing.basicoHora}/>
                    <input name="adicional" type="number" onChange={(e)=>handleChange(e)} value={categoriaEditing.adicional}/>
                </div> 
                : 
                categoriasData.map((c,i) => <div className="categoriaLoaded" key={i}>
                    <FontAwesomeIcon className="iconDelete" icon={faBackspace} color="red" onClick={(e)=>handleDelete(c,i)}/>
                    <input name="codigo" onChange={(e)=>handleChange(e,i)} value={c.codigo}/>
                    <input name="descrp" onChange={(e)=>handleChange(e,i)} value={c.descrp}/>
                    <input name="basico" onChange={(e)=>handleChange(e,i)} value={c.basico}/>
                    <input name="basicoHora" onChange={(e)=>handleChange(e,i)} value={c.basicoHora}/>
                    <input name="adicional" type="number" onChange={(e)=>handleChange(e,i)} value={c.adicional}/>
                </div>)}
            </div>
            {Object.keys(categoriaEditing).length == 0 && <a href="/templateCategoriaRRHH.xlsx" download>Descargar template.xlsx</a>}
            {Object.keys(categoriaEditing).length == 0 && <div className="inputFileXlsx dropNivel1" 
                onClick={() => fileInputRef.current.click()}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
            >
                <span  accept=".xlsx,.xls" htmlFor='excelFile'>O cargue los productos arrastrando un archivo .xlsx a esta sección</span>
                <input ref={fileInputRef} type="file" id="excelFile" style={{display:'none'}} onChange={(e)=>handleChangeFile(e)} />
            </div>}
            <button className="saveBtn" onClick={handleSave}>Guardar</button>
        </div>
    </div>
}

export default AbmCategoriasRRHH;